import { type AxiosInstance } from "axios";

export const postPictureRequestFileApi = async (
  apiClient: AxiosInstance,
  file: File
): Promise<Array<Record<string, string>>> => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiClient.post<Array<Record<string, string>>>(
    "/picture-request/file",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return res.data;
};
